<script setup lang="ts">
import { addDays, isToday } from 'date-fns';
import { computed, ref } from 'vue';
import { formatDate } from '@/utils/format-date';
import beginReturnModal from '../begin-return-modal.vue';

interface Props {
  productBooking: ProductBooking
}

const props = defineProps<Props>();

const returnDate = computed(() => addDays(new Date(props.productBooking.endDate), 1));
const returnToday = computed(() => isToday(returnDate.value));

const showBeginReturnModal = ref(false);
function toggleBeginReturnModal() {
  showBeginReturnModal.value = !showBeginReturnModal.value;
}
</script>
<template>
  <div class="flex flex-col">
    <base-tip
      v-if="returnToday"
      title="Hoy es la devolución"
      variant="bold"
    >
      Coordina la devolución del producto con el socio a través del
      <a
        :href="`/chats/${productBooking.chatId}`"
        class="font-medium underline underline-offset-2"
      >
        chat
      </a>.
    </base-tip>
    <base-tip
      v-else
      title="Devolución"
      variant="bold"
    >
      Recuerda que la devolución será el {{ formatDate(returnDate.toDateString()) }} antes del mediodía.
    </base-tip>
    <base-button
      v-if="!productBooking.productBookingReturn"
      size="sm"
      class="mt-3"
      @click="toggleBeginReturnModal"
    >
      Realizar la devolución
    </base-button>
    <base-button
      v-else-if="productBooking.productBookingReturn?.status === 'awaiting_geolocation'"
      size="sm"
      class="mt-3"
      :href="`/perfil/solicitudes_reservas/${productBooking.id}/ubicacion`"
    >
      Reanudar la devolución
    </base-button>
    <base-button
      v-else-if="productBooking.productBookingReturn?.status === 'ongoing'"
      class="mt-3"
      disabled
      size="sm"
    >
      Esperando al socio
    </base-button>
  </div>
  <begin-return-modal
    v-if="showBeginReturnModal"
    :open="showBeginReturnModal"
    :product-booking-id="productBooking.id"
    :chat-id="productBooking.chatId"
    :address="productBooking.address as AddressData"
    @close="toggleBeginReturnModal"
  />
</template>
